import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/firstBootSurvey/caikuma_03.svg'


const _withScopeId = n => (_pushScopeId("data-v-7d7d00ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-tab" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-header-notch" }, null, -1))
const _hoisted_3 = { className: "orders-area" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex justify-content-center my-2" }
const _hoisted_6 = {
  key: 1,
  class: "empty-orders"
}
const _hoisted_7 = { class: "font-weight-bold text-mild mb-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "caikuma-jump"
}, null, -1))
const _hoisted_9 = { class: "empty-orders-text" }
const _hoisted_10 = {
  key: 0,
  class: "p-3 bg-white text-14 text-center"
}
const _hoisted_11 = ["hidden"]

import { computed, getCurrentInstance, onMounted, PropType, watch } from "vue";
import { SlimOrder } from "@/types/order/Order";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import OrderCardSimple from "@/components/organisms/orders/OrderCardSimple.vue";
import { useCustomRouter } from "@/utils/router";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import { orderStore } from "@/store/order";
import { useToast } from "@/utils/toast";
import {
  AnalyzeWatchLaterEvent,
  eventService
} from "@/app/services/EventService";
import { formatFromISOString } from "@/utils/date";
import { authStore } from "@/store/auth";
import { officeService } from "@/app/services/OfficeService";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchTargetingOrders',
  props: {
  orders: {
    type: Array as PropType<SlimOrder[]>,
    required: true
  },
  isAllOrdersLoaded: {
    type: Boolean,
    required: true
  },
  pageTitleWhenEmpty: {
    type: String,
    required: true
  },
  transitionSource: {
    type: String as PropType<
      "SearchLimitedOrders" | "SearchIndividualOfferOrders"
    >,
    required: true
  }
},
  emits: ["fetch-orders"],
  setup(__props, { emit: emits }) {

const props = __props;





const loader = useLoader();
const { showErrorModal } = useErrorModal();
const { pushIgnoreError } = useCustomRouter();
const toast = useToast();
const instance = getCurrentInstance();

const evaluations = computed(() => orderStore.evaluations || {});
const watchLaterOrders = computed(() => orderStore.watchLaterOrderList || []);
const isLogin = computed(() => authStore.existToken);

const fetchEvaluation = async (officeIds: number[]) => {
  const existsOrderIds = Object.keys(evaluations.value);
  const requestOfficeIds = [
    ...new Set(
      officeIds.filter(
        officeId => !existsOrderIds.includes(officeId.toString())
      )
    )
  ];
  if (requestOfficeIds.length === 0) {
    return;
  }
  try {
    const evaluationsResponse = await officeService.fetchEvaluations({
      officeIds: requestOfficeIds
    });
    orderStore.addEvaluations(evaluationsResponse);
  } catch (e) {
    showErrorModal(e as Error);
  }
};

watch(
  () => props.orders,
  async () => {
    await fetchEvaluation(props.orders.map(order => order.office.id));
  }
);

const ordersAggregateByDate = computed(() => {
  const ordersByDate: {
    date: string;
    orders: SlimOrder[];
  }[] = [];
  props.orders.forEach(order => {
    if (ordersByDate.find(o => o.date === order.date)) {
      // 既に表示中の日付と同日の案件があれば、
      // その日付の案件リストに追加する
      ordersByDate.find(o => o.date === order.date)?.orders.push(order);
    } else {
      // 表示中の案件の日付と異なる場合は、新たに日付を追加する
      ordersByDate.push({
        date: order.date,
        orders: [order]
      });
    }
  });
  return ordersByDate;
});

onMounted(async () => {
  loader.show();
  try {
    await fetchEvaluation(props.orders.map(order => order.office.id));

    // 画面下部までスクロールされたときに追加の案件を読み込む
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 画面下部までスクロールされる && 未読み込みの案件がある場合に追加の案件を読み込む
        if (entry.isIntersecting && !props.isAllOrdersLoaded) {
          emits("fetch-orders");
        }
      },
      { threshold: 0 }
    );
    const bottomRef = instance?.proxy!.$refs.bottomRef as HTMLElement;
    observer.observe(bottomRef);
  } catch (e) {
    showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const getEvaluation = (order: SlimOrder) => {
  if (!authStore.existToken) {
    return null;
  }
  return evaluations.value[order.office.id] || null;
};

const isRegisteredWatchLater = (order: SlimOrder) => {
  return !!watchLaterOrders.value.find(o => o.id === order.id);
};

const onWatchLaterChange = (order: SlimOrder) => {
  const isRegistered = isRegisteredWatchLater(order);
  if (isRegistered) {
    orderStore.removeFromWatchLaterOrderList(order.id);
  } else {
    orderStore.addToWatchLaterOrderList(order);
  }
  toast.toast(
    isRegistered
      ? "あとで見るリストから削除しました"
      : "あとで見るリストに登録しました",
    {
      toastClass: "toast-custom",
      toaster: "router-link-toaster",
      autoHideDelay: 2000,
      to: "/mypage/watch-later-orders"
    }
  );
  // イベントログを記録する。非同期で十分なのでawaitしない
  eventService.registerEvent(
    AnalyzeWatchLaterEvent.group,
    isRegistered
      ? AnalyzeWatchLaterEvent.types.removeOnSearchPage
      : AnalyzeWatchLaterEvent.types.addOnSearchPage,
    undefined,
    JSON.stringify({
      watchLaterCount: orderStore.watchLaterOrderList.length,
      orderId: order.id
    })
  );
};

const formatDate = (date: string) => {
  return formatFromISOString(date, "yyyy年M月d日(iiiii)");
};

const onCardClick = async (orderId: number) => {
  await pushIgnoreError({
    name: "OrdersDetail",
    params: { orderId: `${orderId}` },
    query: {
      transitionSource: props.transitionSource
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(),
      _renderSlot(_ctx.$slots, "orderTab")
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "ad"),
      _createTextVNode(),
      (ordersAggregateByDate.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordersAggregateByDate.value, ({ date, orders }) => {
              return (_openBlock(), _createElementBlock("div", { key: date }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(formatDate(date)), 1),
                _createTextVNode(),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders, (order) => {
                  return (_openBlock(), _createBlock(OrderCardSimple, {
                    key: order.id,
                    order: order,
                    isLogin: isLogin.value,
                    isRegisteredWatchLater: isRegisteredWatchLater(order),
                    id: order.id,
                    class: "my-2 mx-2",
                    evaluation: getEvaluation(order),
                    onCardClick: onCardClick,
                    onChangeWatchLater: ($event: any) => (onWatchLaterChange(order))
                  }, null, 8, ["order", "isLogin", "isRegisteredWatchLater", "id", "evaluation", "onChangeWatchLater"]))
                }), 128))
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.pageTitleWhenEmpty), 1),
            _createTextVNode(),
            _hoisted_8,
            _createTextVNode(),
            _createElementVNode("p", _hoisted_9, [
              _renderSlot(_ctx.$slots, "emptyDescription")
            ])
          ]))
    ]),
    _createTextVNode(),
    (__props.isAllOrdersLoaded)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, "\n    ここが最後です\n  "))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("div", {
      ref: "bottomRef",
      hidden: ordersAggregateByDate.value.length === 0
    }, null, 8, _hoisted_11),
    _createTextVNode(),
    _createVNode(AppFooter)
  ], 64))
}
}

})